let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8bZKp"), load("g4FYy"), load("6wr18"), load("fVzkJ"), load("ffEVr"), load("7EorR"), load("axhR6")]).then(() => parcelRequire('eQcFt'));